
import React from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import ParticipantProfile from "../pages/ParticipantProfile";
import ChangePassword from "../pages/ChangePassword";
import { UserRoles } from "@/contexts/auth/enums";
import ParticipantLayout from "@/pages/organizer/ParticipantLayout";
import { sendPageView } from "@/services/analyticsService";

const ParticipantRoutes = (): RouteObject[] => [
  {
    path: "/participant/profile",
    element: (
      <ProtectedRoute 
        requireAuth={true}
        requiredRole={UserRoles.USER}
        onEnter={() => sendPageView("Résztvevői profil")}
      >
        <ParticipantLayout>
          <ParticipantProfile />
        </ParticipantLayout>
      </ProtectedRoute>
    )
  },
  {
    path: "/participant/change-password",
    element: (
      <ProtectedRoute 
        requireAuth={true}
        requiredRole={UserRoles.USER}
        onEnter={() => sendPageView("Jelszó módosítás - Résztvevő")}
      >
        <ParticipantLayout>
          <ChangePassword />
        </ParticipantLayout>
      </ProtectedRoute>
    )
  }
];

export default ParticipantRoutes;
